import { useTranslation } from 'react-i18next';
import {Icon, Button, Modal, Typography } from '@weirgroup/weir-dls'
import "./styles.scss";
import { LoadingSpinner } from '../loading-spinner';
interface Props {
    isConfirmOpen: boolean
    confirmHandler: (notification_id?: number) => void
    cancelHandler: () => void
    showLoader?: boolean;
    confirmMessage?: string,
    darkMode?: boolean
}

export const ConfirmDialog = (props: Props) => {
    const { isConfirmOpen, confirmHandler, cancelHandler, showLoader, confirmMessage, darkMode } = props;
    const { t } = useTranslation();

    return (
        <div className="dialog-container">
            {showLoader ? 
                <LoadingSpinner darkMode={darkMode} />
                 : <></>}
            <Modal
                darkMode={darkMode}
                showModal={isConfirmOpen}
                onClose={()=>cancelHandler()}
                size="small"
                dismissable
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div className="dialog-header">
                    <Icon darkMode={darkMode} name={"Warning"} size="24" color={props.darkMode ? "white" : "black"} />
                    <Typography darkMode={darkMode} variant="H3" color={props.darkMode ? "white" : "black"} >
                        {t("confirm")}
                    </Typography>
                </div>
                <div className="dialog-message">
                    <Typography darkMode={darkMode} variant="B1" color={props.darkMode ? "white" : "black"}>
                        {confirmMessage ?? t("deleteMessage")}
                    </Typography>
                </div>
                <div className="dialog-actions">
                    <Button
                        darkMode={darkMode}
                        label={t("cancel").toUpperCase()}
                        onClick={() => cancelHandler()}
                        outerContainerPadding="20px"
                        size="sm"
                        variant="secondary"
                    />
                    <Button
                        darkMode={darkMode}
                        label={t("ok").toUpperCase()}
                        onClick={() => confirmHandler()}
                        outerContainerPadding="20px"
                        size="sm"
                        variant="primary"
                    />
                </div>
            </Modal>
        </div>
    )
}